import fetch from 'isomorphic-fetch';
import { toastsActions } from '@zola-helpers/client';

import ApiService from '../util/api';
import * as ActionType from './types/RegistryBulkImportActionTypes';
import { hideModal } from './ModalActions';

const receiveOtherRegistries = response => ({
  type: ActionType.RECEIVE_OTHER_REGISTRIES,
  data: response
});

export const setRegistryUrlError = response => ({
  type: ActionType.VALIDATE_URL_ERROR,
  data: response
});

export function getOtherRegistries() {
  return dispatch => ApiService.get('/web-api/v1/scraper/other-registries')
    .then((json) => {
      dispatch(receiveOtherRegistries(json));
    });
}

export function deleteOtherRegistry(retailerName, registryId) {
  return dispatch => (
    fetch(`/web-api/v1/scraper/delete-imported-registry/${registryId}`,
      {
        method: 'DELETE',
        credentials: 'same-origin'
      })
      .then(() => {
        dispatch(getOtherRegistries());
        dispatch(hideModal());
        const headline = `Your ${retailerName} registry has been removed from Zola.`;
        return dispatch(toastsActions.negative({ headline }));
      })
  );
}


export const editOtherRegistryUrl = (retailerDomain, registryUrl, otherRegistryId, retailerName) => (dispatch) => {
  ApiService.put('/web-api/v1/scraper/edit-registry-schedule', { retailerDomain, registryUrl, otherRegistryId })
    .then(() => {
      dispatch(getOtherRegistries());
      dispatch(hideModal());
      const headline = `Your ${retailerName} registry URL has been updated.`;
      return dispatch(toastsActions.positive({ headline }));
    })
    .catch(() => {
      dispatch(setRegistryUrlError(true));
    });
};



// WEBPACK FOOTER //
// ./src/actions/RegistryBulkImportActions.js